/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Point_Pilot_TitleInputs */

const en_contact_point_pilot_title = /** @type {(inputs: Contact_Point_Pilot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pilot on your own archive`)
};

/**
* | output |
* | --- |
* | "A pilot on your own archive" |
*
* @param {Contact_Point_Pilot_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_point_pilot_title = /** @type {((inputs?: Contact_Point_Pilot_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Point_Pilot_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_point_pilot_title(inputs)
});